import { LeftOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Badge,
  Button,
  Calendar,
  Card,
  Col,
  Form,
  Input,
  Row,
  Select
} from "antd";
import dayjs from "dayjs";
import $ from "jquery";
import { debounce } from "lodash";
import moment from "moment";
import "moment/locale/en-gb";
import React, { useEffect, useState } from "react";
import { IoMenu } from "react-icons/io5";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import apiFactory from "../../../api";
import { CalendarModal } from "../../../components/modal/CalendarModal";
import { SideBarCalendar } from "../../../components/sideBar/SideBarCalendar";
import { AUTHORITY_CONFIG } from "../../../config/Constant";
import { useSideBarStore } from "../../../store/SideBarStore";
import { useInfoUser } from "../../../store/UserStore";
import {getUserPermissions, openNotificationError, openNotificationSuccess} from "../../../utils/Utils";
import "./style.scss";

const ScheduleProject = () => {
  const { projectCode } = useParams();
  const { user, languageMap } = useInfoUser();
  const { switchIsWorkManagementOptions, isWorkManagementOptions } =
    useSideBarStore((state) => state);
  const [form] = Form.useForm();
  const [calendars, setCalendars] = useState([]);
  const [isOpenModal, setIsOpenModal] = useState(false);
  const [titleModal, setTitleModal] = useState("");
  const [calendar, setCalendar] = useState({});
  const [selectDate, setSelectDate] = useState(new Date());
  const [month, setMonth] = useState(dayjs(new Date()).month());
  const [year, setYear] = useState(dayjs(new Date()).year());
  const [formData, setFormData] = useState([]);
  const [isOpenDrawer, setIsOpenDrawer] = useState(false);
  const [permissionCurrentUser, setPermissionCurrentUser] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const fetchProjectDetails = async () => {
    const result = await apiFactory.projectApi.getProjectDetail(projectCode);

    if (result?.status !== 200) {
      openNotificationError(result?.message);
      return;
    }
    const permission = getUserPermissions(
      projectCode,
      AUTHORITY_CONFIG.PROJECT.ID,
      user?.userCode,
      result?.data.projectAuthorityDtos,
      result?.data.projectParticipantDtos
    );

    setPermissionCurrentUser(permission);
  };

  const fetchCalendar = async () => {
    try {
      const values = await form.validateFields();
      const req = {
        ...values,
        startTime: dayjs(
          `${new Date().getFullYear()}-${new Date().getMonth() + 1}-01`
        ).startOf("month"),
        endTime: dayjs(
          `${new Date().getFullYear()}-${new Date().getMonth() + 1}-01`
        ).endOf("month"),
        projectId: projectCode,
      };

      const result = await apiFactory.calendarApi.getCalendar(req);

      if (result?.status === 200 || result?.status === 400) {
        setCalendars(result?.data?.length > 0 ? result?.data : []);
      } else {
        openNotificationError(result?.message);
      }
    } catch (error) {
      openNotificationError(error?.error);
    }
  };

  const handleClickItem = (event, data) => {
    event?.preventDefault();
    let objData = {};
    const newSelectDate = new Date(selectDate);
    const now = new Date();

    if (
      newSelectDate.getDate() === now.getDate() &&
      newSelectDate.getMonth() + 1 === now.getMonth() + 1 &&
      newSelectDate.getFullYear() === now.getFullYear()
    ) {
      objData = { ...data };
    } else {
      objData = {
        ...data,
        selectDate: newSelectDate,
      };
    }

    if (data?.calendarId) {
      setTitleModal(
        languageMap?.["event.dashboard.myProject.calendar.moda.title.edit"] ??
          "Edit Calendar"
      );
    } else {
      setTitleModal(
        languageMap?.["event.dashboard.myProject.calendar.moda.title"] ??
          "Add Calendar"
      );
    }

    setCalendar(objData);
    setIsOpenModal(true);
  };

  const dateCellRender = (value) => {
    const formattedDate = value?.format("YYYY-MM-DD");

    const getDatesInRange = (start, end) => {
      let dates = [];
      let current = moment(start);
      let endDate = moment(end);

      while (current.isSameOrBefore(endDate, "day")) {
        dates.push(current.format("YYYY-MM-DD"));
        current = current.add(1, "days");
      }

      return dates;
    };

    const startOfMonth = value.startOf("month");
    const endOfMonth = value.endOf("month");

    const dailyEvents = calendars?.filter((data) => {
      if (data) {
        let eventDates = [];
        let startIntersection = dayjs(data?.startTime);
        let endIntersection = dayjs(data?.endTime);

        const isWithinMonth =
          startIntersection.isBefore(endOfMonth) &&
          endIntersection.isAfter(startOfMonth);

        if (
          isWithinMonth ||
          startIntersection.isBefore(startOfMonth) ||
          endIntersection.isAfter(endOfMonth)
        ) {
          eventDates = getDatesInRange(
            startIntersection.format("YYYY-MM-DD"),
            endIntersection.format("YYYY-MM-DD")
          );

          return eventDates.includes(formattedDate);
        }
      }

      return false;
    });

    return (
      <ul className="events">
        {dailyEvents?.map((data) => (
          <div className="flex items-center" key={data?.calendarId}>
            <Badge
              status={
                data?.projectScope
                  ? "success"
                  : data?.createdBy === user?.userCode
                    ? "warning"
                    : "error"
              }
            />
            <span
              className="text-black text-xs hover:text-blue-500 cursor-pointer ml-1"
              onClick={(event) => handleClickItem(event, data)}
            >
              {getContentEvent(data)}
            </span>
          </div>
        ))}
      </ul>
    );
  };

  const dateCellRenderMobile = (value) => {
    const formattedDate = value?.format("YYYY-MM-DD");

    const getDatesInRange = (start, end) => {
      let dates = [];
      let current = moment(start);
      let endDate = moment(end);

      while (current.isSameOrBefore(endDate, "day")) {
        dates.push(current.format("YYYY-MM-DD"));
        current = current.add(1, "days");
      }

      return dates;
    };

    const startOfMonth = value.startOf("month");
    const endOfMonth = value.endOf("month");

    const dailyEvents = calendars?.filter((data) => {
      if (data) {
        let eventDates = [];
        let startIntersection = dayjs(data?.startTime);
        let endIntersection = dayjs(data?.endTime);

        const isWithinMonth =
          startIntersection.isBefore(endOfMonth) &&
          endIntersection.isAfter(startOfMonth);

        if (
          isWithinMonth ||
          startIntersection.isBefore(startOfMonth) ||
          endIntersection.isAfter(endOfMonth)
        ) {
          eventDates = getDatesInRange(
            startIntersection.format("YYYY-MM-DD"),
            endIntersection.format("YYYY-MM-DD")
          );

          return eventDates.includes(formattedDate);
        }
      }

      return false;
    });

    return (
      <ul className="events">
        {dailyEvents && dailyEvents.length > 0 && (
          <div className="absolute top-0 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-2 h-2 bg-red-500 rounded-full"></div>
        )}
      </ul>
    );
  };

  const getMonthData = (value) => {
    const formattedMonth = value.format("YYYY-MM");
    const yearEvents = calendars?.filter(
      (data) => moment(data?.startTime).format("YYYY-MM") === formattedMonth
    );

    return {
      key: yearEvents.length,
      value: yearEvents.map((data) => (
        <div className="flex items-center" key={data?.calendarId}>
          <Badge
            status={
              data?.projectScope
                ? "success"
                : data?.createdBy === user?.userCode
                  ? "warning"
                  : "error"
            }
          />
          <span
            className="text-black text-xs hover:text-blue-500 cursor-pointer ml-1"
            onClick={(event) => handleClickItem(event, data)}
          >
            {getContentEvent(data?.content)}
          </span>
        </div>
      )),
    };
  };

  const monthCellRender = (value) => {
    const yearData = getMonthData(value);

    return yearData?.key ? (
      <div className="notes-month" key={yearData?.key}>
        {yearData?.value}
      </div>
    ) : null;
  };

  const cellRender = (current, info) => {
    if (info.type === "date") return dateCellRender(current);
    if (info.type === "month") return monthCellRender(current);

    return info.originNode;
  };

  const cellRenderMobile = (current, info) => {
    if (info.type === "date") return dateCellRenderMobile(current);
    if (info.type === "month") return monthCellRender(current);

    return info.originNode;
  };

  const handleSelect = async (date) => {
    const newSelectDate = new Date(date);

    if (
      dayjs(newSelectDate).month() !== month ||
      dayjs(newSelectDate).year() !== year
    ) {
      setMonth(dayjs(newSelectDate).month());
      setYear(dayjs(newSelectDate).year());
      debounceSearch();
    }

    setSelectDate(newSelectDate);
  };

  const locale = {
    lang: {
      locale: "en_US",
      placeholder: "Select date",
      rangePlaceholder: ["Start date", "End date"],
      today: "Today",
      now: "Now",
      backToToday: "Back to today",
      ok: "OK",
      clear: "Clear",
      month: languageMap?.["dateTime.month"] ?? "month",
      year: languageMap?.["dateTime.year"] ?? "year",
      timeSelect: "Select time",
      dateSelect: "Select date",
      monthSelect: "Choose a month",
      yearSelect: "Choose a year",
      decadeSelect: "Choose a decade",
      yearFormat: "YYYY",
      dateFormat: "M/D/YYYY",
      dayFormat: "D",
      dateTimeFormat: "M/D/YYYY HH:mm:ss",
      monthFormat: "MMMM",
      monthBeforeYear: true,
      previousMonth: "Previous month (PageUp)",
      nextMonth: "Next month (PageDown)",
      previousYear: "Last year (Control + left)",
      nextYear: "Next year (Control + right)",
      previousDecade: "Last decade",
      nextDecade: "Next decade",
      previousCentury: "Last century",
      nextCentury: "Next century",
      shortWeekDays: [
        languageMap?.["dateTime.week.sun"] ?? "Sun",
        languageMap?.["dateTime.week.mon"] ?? "Mon",
        languageMap?.["dateTime.week.tue"] ?? "Tue",
        languageMap?.["dateTime.week.wed"] ?? "Wed",
        languageMap?.["dateTime.week.thu"] ?? "Thu",
        languageMap?.["dateTime.week.fri"] ?? "Fri",
        languageMap?.["dateTime.week.sat"] ?? "Sat",
      ],
      shortMonths: [
        languageMap?.["dateTime.month.jan"] ?? "Jan",
        languageMap?.["dateTime.month.feb"] ?? "Feb",
        languageMap?.["dateTime.month.mar"] ?? "Mar",
        languageMap?.["dateTime.month.apr"] ?? "Apr",
        languageMap?.["dateTime.month.may"] ?? "May",
        languageMap?.["dateTime.month.jun"] ?? "Jun",
        languageMap?.["dateTime.month.jul"] ?? "Jul",
        languageMap?.["dateTime.month.aug"] ?? "Aug",
        languageMap?.["dateTime.month.sep"] ?? "Sep",
        languageMap?.["dateTime.month.oct"] ?? "Oct",
        languageMap?.["dateTime.month.nov"] ?? "Nov",
        languageMap?.["dateTime.month.dec"] ?? "Dec",
      ],
    },
    timePickerLocale: {
      placeholder: "Select time",
    },
    dateFormat: "YYYY-MM-DD",
    dateTimeFormat: "YYYY-MM-DD HH:mm:ss",
    weekFormat: "YYYY-wo",
    monthFormat: "YYYY-MM",
  };

  function getContentEvent(data) {
    return (data?.type + " (" + data?.createdByName + ")").toUpperCase();
  }

  const handleSubmitModal = async (isSuccess) => {
    setIsOpenModal(false);
    if (isSuccess) {
      debounceSearch();
    }
  };

  const handleDeleteItem = async (id) => {
    setIsOpenModal(false);
    try {
      const result = await apiFactory.calendarApi.deleteItem(id);

      if (result?.status === 200) {
        debounceSearch();
        openNotificationSuccess("Delete event data successfully");
      } else {
        openNotificationError("Failed to delete event data");
      }
    } catch (error) {
      openNotificationError("Failed to delete event data");
    }
  };

  const searchCalendar = async (values) => {
    try {
      if (isLoading) return;

      setIsLoading(true);
      const req = {
        startTime: dayjs(`${year}-${month + 1}-01`).startOf("month"),
        endTime: dayjs(`${year}-${month + 1}-01`).endOf("month"),
        content: values?.content,
        projectScope: values?.projectScope,
        type: values?.type,
        projectId: projectCode,
      };

      setFormData(req);
      const result = await apiFactory.calendarApi.getCalendar(req);

      if (result?.status === 200 || result?.status === 400) {
        setCalendars(result?.data);
      } else {
        openNotificationError(result?.message);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      openNotificationError("Failed to fetch calendar data.");
    }
  };

  const applyWeekendStyles = () => {
    $(".ant-picker-cell").each(function () {
      const dateStr = $(this).attr("title");
      const pattern = /^\d{4}-\d{2}-\d{2}$/;

      if (!dateStr) return;

      if (!pattern.test(dateStr)) return;

      const date = dayjs(dateStr);
      if (date.day() === 6 || date.day() === 0) {
        $(this).css("background-color", "#d7eaff");
      }
    });
  };

  const handlePanelChange = (value) => {
    setTimeout(applyWeekendStyles, 50);
  };

  const renderContentMobile = () => {
    if (calendars?.length > 0) {
      const formattedSelectDate = dayjs(selectDate).format("YYYY-MM-DD");

      const filteredEvents = calendars?.filter((data) => {
        const eventStartDate = data?.startTime?.split(" ")[0];
        const eventEndDate = data?.endTime?.split(" ")[0];

        return (
          formattedSelectDate >= eventStartDate &&
          formattedSelectDate <= eventEndDate
        );
      });

      return filteredEvents?.map((data) => (
        <Card
          onClick={() => handleClickItem(null, data)}
          className="card-calendar-event"
          key={data?.calendarId}
          title={false}
          bordered={false}
          size="small"
        >
          <p className="text-xs mb-2">{getContentEvent(data)}</p>
          <small>
            {data?.startTime} - {data?.endTime}
          </small>
        </Card>
      ));
    }
  };

  const debounceSearch = debounce(() => {
    form?.submit();
  }, 500);

  useEffect(() => {
    fetchCalendar();
  }, []);

  useEffect(() => {
    if (projectCode && user) {
      fetchProjectDetails();
    }
  }, [projectCode, user]);

  useEffect(() => {
    applyWeekendStyles();
  }, []);

  const customHeaderRender = ({ value, onChange }) => {
    const year = value.year();
    const month = value.month();
    const currentYear = dayjs().year();

    const monthOptions = [];
    for (let i = 0; i < 12; i++) {
      monthOptions.push(
        <Select.Option key={i} value={i}>
          {value.clone().month(i).format("MMM")}
        </Select.Option>
      );
    }

    const yearOptions = [];
    for (let i = year - 10; i < year + 10; i++) {
      yearOptions.push(
        <Select.Option key={i} value={i}>
          {i}
        </Select.Option>
      );
    }

    if (year - 10 > currentYear) {
      yearOptions.unshift(
        <Select.Option
          key={currentYear}
          value={currentYear}
          className="bg-[#89dfff]"
        >
          {currentYear}
        </Select.Option>
      );
    } else if (year + 10 < currentYear) {
      yearOptions.push(
        <Select.Option
          key={currentYear}
          value={currentYear}
          className="bg-[#89dfff]"
        >
          {currentYear}
        </Select.Option>
      );
    }

    const onYearChange = (newYear) => {
      const newValue = value.clone().year(newYear);
      onChange(newValue);
      setYear(dayjs(newValue).year());
      debounceSearch();
    };

    const onMonthChange = (newMonth) => {
      const newValue = value.clone().month(newMonth);
      onChange(newValue);
      setMonth(dayjs(newValue).month());
      debounceSearch();
    };

    return (
      <div>
        <Form
          className="pc-screen mb-[30px] mt-5"
          form={form}
          name="searchCalendarForm"
          onFinish={searchCalendar}
        >
          <Row gutter={[4, 16]} className="pb-3">
            <Col span={6}>
              <Form.Item
                className="mb-0"
                name="content"
                wrapperCol={{ span: 24 }}
                labelCol={{ span: 8 }}
              >
                <Input
                  addonAfter={<SearchOutlined />}
                  placeholder={
                    languageMap?.[
                      "event.dashboard.myProject.calendar.searchPlah"
                    ] ?? "Search events content"
                  }
                  allowClear
                  onChange={debounceSearch}
                />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item
                className="mb-0"
                name="type"
                wrapperCol={{ span: 24 }}
                labelCol={{ span: 8 }}
              >
                <Select
                  style={{ width: "100%" }}
                  defaultValue={null}
                  options={[
                    {
                      value: null,
                      label:
                        languageMap?.[
                          "event.dashboard.myProject.calendar.scheduleType.all"
                        ] ?? "All",
                    },
                    {
                      value: "WORK",
                      label:
                        languageMap?.[
                          "event.dashboard.myProject.calendar.scheduleType.work"
                        ] ?? "Work",
                    },
                    {
                      value: "BUSINESS_TRIP",
                      label:
                        languageMap?.[
                          "event.dashboard.myProject.calendar.scheduleType.businessTrip"
                        ] ?? "Business trip",
                    },
                    {
                      value: "VACATION",
                      label:
                        languageMap?.[
                          "event.dashboard.myProject.calendar.scheduleType.vacation"
                        ] ?? "Vacation",
                    },
                    {
                      value: "ETC",
                      label:
                        languageMap?.[
                          "event.dashboard.myProject.calendar.scheduleType.etc"
                        ] ?? "Etc",
                    },
                  ]}
                  onChange={debounceSearch}
                />
              </Form.Item>
            </Col>

            <Select className=" ml-[2px]" value={year} onChange={onYearChange}>
              {yearOptions}
            </Select>

            <Select
              className=" ml-[2px]"
              value={month}
              onChange={onMonthChange}
            >
              {monthOptions}
            </Select>
            <Button
              htmlType="submit"
              className={`ml-[3px] ${!permissionCurrentUser?.includes("C") ? "hidden" : ""}`}
              onClick={(e) => handleClickItem(e, {})}
            >
              <span>
                <PlusOutlined className="mr-1" />
                {languageMap?.[
                  "event.dashboard.myProject.calendar.createBtn"
                ] ?? "Create"}
              </span>
            </Button>
          </Row>
        </Form>
      </div>
    );
  };

  return (
    <>
      <div className="p-4">
        <Row className="">
          <Col span={22} className="flex justify-start">
            {!isWorkManagementOptions && (
              <a
                className="btn-back-to-work-management"
                onClick={switchIsWorkManagementOptions}
              >
                <LeftOutlined size={25} />
              </a>
            )}
          </Col>
          <Col span={2} className="flex justify-end">
            <a
              className="mobile-screen hover:cursor-pointer"
              onClick={() => {
                setIsOpenDrawer(true);
              }}
            >
              <IoMenu size={25} />
            </a>
          </Col>
        </Row>
        <Row className="pc-screen">
          <Col span={24}>
            <Calendar
              key={"calendar-pc-screen"}
              onPanelChange={handlePanelChange}
              onSelect={(date) => {
                handleSelect(date);
              }}
              cellRender={cellRender}
              locale={locale}
              className="schedule-calendar-header"
              headerRender={customHeaderRender}
            />
          </Col>
        </Row>
        <Row className="mobile-screen">
          <Col span={24}>
            <Calendar
              key={"calendar-mobile-screen"}
              onPanelChange={handlePanelChange}
              onSelect={(date) => {
                handleSelect(date);
              }}
              locale={locale}
              fullscreen={false}
              cellRender={cellRenderMobile}
              headerRender={customHeaderRender}
            />
          </Col>
        </Row>
        <Row className="mobile-screen">
          <Col span={24}>{calendars?.length > 0 && renderContentMobile()}</Col>
        </Row>
      </div>
      {isOpenModal && (
        <CalendarModal
          open={isOpenModal}
          title={titleModal}
          data={calendar}
          permissionCurrentUser={permissionCurrentUser}
          onSubmit={handleSubmitModal}
          onCancel={() => setIsOpenModal(false)}
          onDeleteItem={handleDeleteItem}
          headerRender={null}
        />
      )}
      {isOpenDrawer && (
        <SideBarCalendar
          isOpen={isOpenDrawer}
          onClose={() => setIsOpenDrawer(false)}
          selectDate={selectDate}
          handleOpenModal={handleClickItem}
          onSearch={searchCalendar}
          form={form}
        />
      )}
    </>
  );
};

export default ScheduleProject;
